import React from 'react';

// Display Components
export const Display = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-display text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const DisplayMedium = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-display-medium text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const DisplaySmall = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-display-small text-${color} ${className}`} {...props}>
    {children}
  </div>
);

// Headline Components
export const HeadlineLarge = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-headline-large text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const HeadlineMedium = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-headline-medium text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const HeadlineSmall = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-headline-small text-${color} ${className}`} {...props}>
    {children}
  </div>
);

// Title Components
export const TitleLarge = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-title-large text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const TitleMedium = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-title-medium text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const TitleSmall = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-title-small text-${color} ${className}`} {...props}>
    {children}
  </div>
);

// Label Components
export const LabelLarge = ({ children, className = '', color = 'gray-300', ...props }) => (
  <div className={`font-inter text-label-large text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const LabelMedium = ({ children, className = '', color = 'gray-300', ...props }) => (
  <div className={`font-inter text-label-medium text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const LabelSmall = ({ children, className = '', color = 'gray-300', ...props }) => (
  <div className={`font-inter text-label-small text-${color} ${className}`} {...props}>
    {children}
  </div>
);

// Body Components
export const BodyLarge = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-inter text-body-large text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const BodyMedium = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-inter text-body-medium text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const BodySmall = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-inter text-body-small text-${color} ${className}`} {...props}>
    {children}
  </div>
);

// Courses-specific Components
export const CoursesTitle = ({ children, className = '', color = 'white', ...props }) => (
  <div className={`font-poppins text-courses-title text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const CourseTitle = ({ children, className = '', color = 'blue-900', ...props }) => (
  <div className={`font-poppins text-course-title text-${color} ${className}`} {...props}>
    {children}
  </div>
);

export const CourseType = ({ children, className = '', color = 'gray-500', ...props }) => (
  <div className={`font-poppins text-course-type text-${color} ${className}`} {...props}>
    {children}
  </div>
);

// Utility function to get typography classes
export const getTypographyClasses = (style, color = 'primary') => {
  const baseClasses = {
    'display': 'font-poppins text-display',
    'display-medium': 'font-poppins text-display-medium',
    'display-small': 'font-poppins text-display-small',
    'headline-large': 'font-poppins text-headline-large',
    'headline-medium': 'font-poppins text-headline-medium',
    'headline-small': 'font-poppins text-headline-small',
    'title-large': 'font-poppins text-title-large',
    'title-medium': 'font-poppins text-title-medium',
    'title-small': 'font-poppins text-title-small',
    'label-large': 'font-inter text-label-large',
    'label-medium': 'font-inter text-label-medium',
    'label-small': 'font-inter text-label-small',
    'body-large': 'font-inter text-body-large',
    'body-medium': 'font-inter text-body-medium',
    'body-small': 'font-inter text-body-small',
  };

  const colorClasses = {
    'primary': 'text-white',
    'secondary': 'text-gray-300',
    'accent': 'text-blue-400',
  };

  return `${baseClasses[style] || ''} ${colorClasses[color] || colorClasses.primary}`;
};
